<template>
    <div>
        <b-modal         
            :ref="modalId" :id="modalId" size="xl" 
             :modal-class="'is-draggable'"
             @shown="prepararDrag"
            scrollable centered :no-close-on-backdrop="true" 
            :no-close-on-esc="true"
            @ok="this.onEventOk" 
            @cancel="this.onEventCancel" 
            @hide="resetModal" 
            :cancel-title="$t('Shared.BtnCancel')"            
            @show="prepararDrag"
        
            
        > 
            <Loading v-bind:IsLoading="this.Load" />  
            <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
       <div class="row">
          <div class="col-md-12">
              <div class="flex-container">
              <div class="row">                
              
              <div class="col-md-3">
                 <MdCheckBox
                  v-bind:Label="$t('Shared.SelectAll')"
                  v-bind:Name="'SelectTableAll'"
                  v-bind:ClassProp="'AlignCheck mx-3'"
                  v-bind:CheckedValue="true"
                  v-bind:isReadOnly="this.items.length === 0"
                  v-bind:UncheckedValue="false"
                  v-model="UseSelectTableAll" 
                  v-on:change="onChangeSelectAll"                
               /> 
              </div>
              <div class="col-md-3 mt-3">
                <span class="tableSelectedItems"><span class="selItemsVal">{{ SelectedRecords }}</span> {{ $t('claimbatchList.item') }}<span v-if="SelectedRecords != 1">s</span> {{ $t('Shared.selected') }}</span>
              </div>  
             <div class="col-md-6">
                       <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                      <div class="input-group" dir="ltr">
                          <input 
                            type="text" 
                            class="form-control"
                            :dir="dirInput"
                            v-model="modelSearch"                          
                            @keyup.enter="FindinItems()"
                          >
                          <div class="input-group-append">
                              <MdButton 
                                v-bind:Name="'btnsearchinput'"
                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'"                               
                                v-on:click="FindinItems()"
                                 >
                              </MdButton>
                          </div>
                      </div>
                  </div>
             </div>                     
              </div>
          </div>            
          <MdTablePaginationClient
            v-bind:fields="fields"
            v-bind:items="items"
            v-bind:totalRows="totalRows"
            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
            v-bind:currentPage="currentPage"
            v-bind:perPage="perPage"
            v-bind:SelectAll="UseSelectTableAll"
            v-bind:pageOptions="pageOptions"
            :onFiltered="onFiltered"
            :onRowSelected="onRowSelected"
            :pageChanged="pageChanged"
            :RowClick="onRowClicked"
            :ondblClick="onRowDblClicked"
            :perPageFunction="PerPageFunction">                
        </MdTablePaginationClient>
          </div>
        </div>           

  <template #modal-title>
    <div class="custom-modal-header">
      {{ TitleWindow }}
    </div>
  </template>
            
        </b-modal>
    </div>
</template>

<script>

import ModalService from '@/services/modal.service'
import ShowMessage from '@/components/messages/ShowMessage.js'
import Loading from '@/components/template/loading/Loading'
import Utils from '@/common/utils'
import { EventBus } from '@/event-bus.js';
  export default {
    mixins: [ShowMessage],
    components: {
        Loading
    },
    props: {
     Fields: Array,
     TypeOption: String,
     Resource:String,
     TitleWindow:String,
     FieldCode:String,    
     FieldDescription:String,
     ModalId: String,
     OptionParamList:Array,
     AuxFields:Array,
     Stacked:[Boolean],
     FieldsDate: Array,
     UseFilter:Boolean,
     modelFilter:Object,   
     ShowAddRecord:Boolean,
     AddRecordLabel:String,
     BackToGridEventName:String,
     OkEventName:String,
     valueToSearch: String,
     ModelCode: Array,
     ReturnAll: Boolean

   },
   watch:{
    ModalId(newId){
      if(newId){
        this.modalId = newId;
      }

    }

   },
    data() {
      return {
        modalId: this.ModalId ? this.ModalId : "bv-modal-table-paginationServer",
        ShowMessageIsEmpty:false,
        parameter:{
          SearchCriteria:'',
          //PageNumber : 1,
          //PageSize:5,
        },    
        Api:"",
        fields:this.Fields, 
        Header:{},          
        pageOptions: [5, 10, 15 ],
        totalRows: 1,
        currentPage: 1,
        perPage: 5,
        items: [],
        rowSelected:[],
        refTable: 'selectableTable',
        Load:true,
        hideDefaultSlot: false,
        dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
        UseSelectTableAll:false,
        modelSearch:"",
        SelectedRecords:0,
        itemsCopy:[],
      }
    },
    

    methods:{

      addItemsToSelected() {
        this.rowSelected = []
        this.items.forEach(el => {
          if (!this.rowSelected.find((item) => { return item === el })) {
            if (this.ReturnAll)
              this.rowSelected.push(el)
            else
              this.rowSelected.push(el[this.FieldCode])
          }
        });
      },

      onChangeSelectAll(v){
        if(v){
          this.SelectedRecords = this.totalRows; 
          for(var i = 0 ; i < this.items.length; i++){
            this.$set(this.items[i], 'selected', true); 
          }
          this.addItemsToSelected()
        }else{
          this.SelectedRecords = 0;
          for(var j= 0 ; j < this.items.length; j++){
            this.$set(this.items[j], 'selected', false);
          }
          this.rowSelected = []
        }
      },

      FindinItems(){
        this.items = this.itemsCopy;
        var arr =  this.items;
        var temp = [];       
        if(this.modelSearch){ 
         arr.forEach(element => {
          this.Fields.forEach(field => {
            if ( typeof element[field.key] === 'string' && element[field.key].toUpperCase().includes(this.modelSearch.toUpperCase())) {
              temp.push(element);
            } 
          })
        });
        }else{
           temp = this.itemsCopy;
        }
         this.items = temp;
         this.totalRows = this.items.length;
      },

      onRowClicked(item) {
          if(item.selected){      
            const index = this.rowSelected.findIndex(element => element === item[this.FieldCode]);
            this.rowSelected.splice(index, 1);
            this.$set(item, 'selected', false);                    
          }else{
            this.$set(item, 'selected', true);
            if (this.ReturnAll)
              this.rowSelected.push(item)
            else
              this.rowSelected.push(item[this.FieldCode])       
          }
          EventBus.$emit('rowClicked', item);

          //this.EnabledAllItems(arritemsSelected);
      },  

      prepararDrag() {
        this.$nextTick(() => {
          const outer = document.getElementById(`${this.ModalId}___BV_modal_outer_`);
          if (!outer) {     
            return;
          }

        const dialog = outer.querySelector(".modal-dialog");
        const header = outer.querySelector(".modal-header");

        if (!dialog || !header) {     
          return;
        }

        if (outer.classList.contains("is-draggable")) 
                return;

        header.style.cursor = "move";

        header.onmousedown = (e) => {
          e.preventDefault();

        // Obtener posición actual antes de tocar estilos
        const rect = dialog.getBoundingClientRect();
        const offsetX = e.clientX - rect.left;
        const offsetY = e.clientY - rect.top;

        // Fijar posición actual (solo en el primer movimiento)
        dialog.style.width = `${rect.width}px`;
        dialog.style.height = `${rect.height}px`;
        dialog.style.position = "fixed";
        dialog.style.left = `${rect.left}px`;
        dialog.style.top = `${rect.top}px`;
        dialog.style.margin = 0;
        dialog.style.transform = "none";

        const moveHandler = (eMove) => {
          dialog.style.left = `${eMove.clientX - offsetX}px`;
          dialog.style.top = `${eMove.clientY - offsetY}px`;
        };

        document.addEventListener("mousemove", moveHandler);
        document.addEventListener(
          "mouseup",
          () => document.removeEventListener("mousemove", moveHandler),
          { once: true }
        );
     };
  });
  },

      emitEventOK(/*bvModalEvt*/){ 
        this.$emit('getCodeConditionOK', this.rowSelected);
        this.ResetProps();
        this.parameter.SearchCriteria="";
          if(this.rowSelected.code !== '')
            EventBus.$emit('IsCorrectCode', true);   
      },

      emitEventCancel(){
        this.$emit('getCodeConditionCancel');
        this.ResetProps();
      }, 

      resetModal(){
        this.parameter.SearchCriteria="";
        this.hideDefaultSlot = false;
      },

      ResetProps(){
        this.items = [];
        this.rowSelected = []
        this.SelectedRecords = 0
        this.UseSelectTableAll = false
        this.modelSearch = ''
        this.hideDefaultSlot = false;
      },

      pageChanged (page) {         
        this.currentPage = page;        
      },

      PerPageFunction(perpage){
       this.perPage = perpage;
       this.currentPage = 1;
      },

      async getData() {         
        if(this.Resource != ''){
          this.Load = true; 
          await ModalService.getAll(this.Resource,this.parameter)
            .then((response) => {
              if (response.status == '200' && response.data) {   
                this.items = response.data;                    
                this.items.forEach(element => {
                  if(this.FieldsDate) {
                    this.FieldsDate.forEach(fieldDate => {
                      if (Utils.isValidDate(element[fieldDate])){
                        element[fieldDate] = Utils.formatterDateToString(element[fieldDate])
                      }
                    });
                  }
                    if(this.TypeOption === 'Program'){
                        element.inPatient = element.isInPatient ? 'Y' : 'N';
                    }                   
                });
                let headerString = response.headers["x-pagination"];
                this.Header = JSON.parse(headerString);       
                this.totalRows = this.Header.TotalCount;
                this.itemsCopy = this.items;
                if(this.items.length === 0) {
                    this.ShowMessageIsEmpty = true;
                }           
              }
              this.Load = false;          
            })
            .catch(error => {
              this.Load = false;
              if (!error.response) {
                    // network error
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
              } else {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
            }); 
        }     
      },

      onRowSelected(item) {  
        this.rowSelected = {
          FieldName:"",
          code:"",
          description:"",
          AuxFields:[]
        };      
        this.rowSelected.FieldName = this.TypeOption;
        this.rowSelected.code = item[0] ? item[0][this.FieldCode] : null;
        this.rowSelected.description = item[0] ? item[0][this.FieldDescription]: null;
     if(this.AuxFields !== undefined){
        if(this.AuxFields.length > 0){
          for(var i = 0; i < this.AuxFields.length; i++){
            if(item[0]){
              this.rowSelected.AuxFields.push(item[0][this.AuxFields[i]]);
            }            
          }
        }
     }     
      },

      selectAllRows() {
        this.$refs.selectableTable.selectAllRows()
      },

      clearSelected() {
        this.$refs.selectableTable.clearSelected()
      },

      selectThirdRow() {
        // Rows are indexed from 0, so the third row is index 2
        this.$refs.selectableTable.selectRow(2)
      },

      unselectThirdRow() {
        // Rows are indexed from 0, so the third row is index 2
        this.$refs.selectableTable.unselectRow(2)
      },

      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      }
      ,
      focusInput() {
        if (this.$refs.inputSearchCriteria)
          this.$refs.inputSearchCriteria.focus();
        
        if (this.valueToSearch) {
          this.modelSearch = this.valueToSearch
          this.FindinItems()
        }
      },

      setZIndex(){
        let editorZIndex = document.getElementById('Schedule_dialog_wrapper') && 
                           document.getElementById('Schedule_dialog_wrapper').style ?
                           Number(document.getElementById('Schedule_dialog_wrapper').style.zIndex) + 1 : null
        if (document.getElementById('ee-334-5rt654___BV_modal_outer_') && document.getElementById('ee-334-5rt654___BV_modal_outer_').style && editorZIndex) {
          document.getElementById('ee-334-5rt654___BV_modal_outer_').style.zIndex = editorZIndex;
        }
      },  

      showDefaultSlot(value) {
        this.hideDefaultSlot = !value;
      },

      onRowDblClicked(item) {
        if (!item.selected) {
          this.$set(item, 'selected', true);
          if (this.ReturnAll) {
            this.rowSelected.push(item);
          } else {
            this.rowSelected.push(item[this.FieldCode]);
          }
        }
        this.emitEventOK();
      },

      onEventOk(event) {
        if (this.hideDefaultSlot) {
            this.hideDefaultSlot = false;
            event.preventDefault();
        } else {
            this.emitEventOK();
        }
      },

      onEventCancel() {
        this.emitEventCancel();
      },

      selectOnLoad() {
        if (this.ModelCode && this.ModelCode.length > 0) {
          this.ModelCode.forEach(select => {
            this.items.forEach(item => {
              if (item[this.FieldCode] === select) {
                this.$set(item, 'selected', true);
                this.rowSelected.push(select)
              }                
            });
          });
          this.SelectedRecords = this.rowSelected.length
        }
      },
    },

    mounted() {
        this.$root.$on('bv::modal::shown', async (bvEvent, _modalId) => { 
        this.currentPage = 1;     
        if(_modalId === this.modalId){ 
          await this.getData();
          this.selectOnLoad()
        }            

        this.currentPage = 1;
        this.setZIndex()     
        this.$nextTick(() => {
          setTimeout(() =>  this.focusInput(), 500);
          });
        });
    },

    created () {
      EventBus.$on("rowClicked", function () {        
        this.SelectedRecords = 0;
            for(var i = 0; i < this.itemsCopy.length; i++){
                if(this.itemsCopy[i].selected){
                    this.itemsCopy[i].counted = true;
                    this.SelectedRecords++;
                }
            }                  
      }.bind(this));
    },

    beforeDestroy () {      
    },
  }

</script>


<style>

.modal-dialog {
  transition: none !important;
  transform: none !important;
}

.modal-dialog.dragging {
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);
  opacity: 0.98;
  cursor: grabbing !important;
  transition: box-shadow 0.2s ease;
}
.modal-header {
  user-select: none; /* evita seleccionar texto al arrastrar */
}
</style>